import { caseStudiesId } from "@/queries/caseStudies"
import { componentCtaCardID } from "@/queries/ctaCard"
import { blogPostsId } from "@/queries/insightsBlogPosts"
import { leadGenLgId, leadGenTyId } from "@/queries/leadGens"
import { legalPageID } from "@/queries/legal"
import { pagesId } from "@/queries/pages"
import { pressReleasesId } from "@/queries/pressReleases"

// Define the content type IDs as a union type
type ContentTypeId =
  | typeof legalPageID
  | typeof blogPostsId
  | typeof caseStudiesId
  | typeof leadGenLgId
  | typeof leadGenTyId
  | typeof pagesId
  | typeof pressReleasesId
  | typeof componentCtaCardID

// Define the possible URL path prefixes
type UrlPathPrefix =
  | "/legal/"
  | "/insights/"
  | "/customer-case-study/"
  | "/lp/"
  | "/"
  | "/ripple-press/"
  | "/ripplenet-committee/"

// Define the content type to URL mapping
type ContentTypeToUrlMapping = Record<string, UrlPathPrefix>

/**
 * Maps a Contentful content type to its corresponding URL path prefix
 * @param contentType - The content type string from Contentful (e.g., "ContentTypeBlogPosts" or "caseStudies")
 * @returns The URL path prefix for the content type
 */
function getContentTypePath(contentType: string): UrlPathPrefix {
  // preview api route content type comes back as ContentType{ID} except for "caseStudies" - so strip out "ContentType" to get the ID
  const contentTypeSplit = contentType.split("ContentType")
  // Content type IDs come back with different letter casing for preview vs Algolia search hits, so make it lowercase for matching
  const contentTypeId: string =
    contentTypeSplit[contentTypeSplit.length - 1].toLowerCase()

  const contentUrlPathPrefixes: ContentTypeToUrlMapping = {
    [legalPageID.toLowerCase()]: "/legal/",
    [blogPostsId.toLowerCase()]: "/insights/",
    [caseStudiesId.toLowerCase()]: "/customer-case-study/",
    [leadGenLgId.toLowerCase()]: "/lp/",
    [leadGenTyId.toLowerCase()]: "/lp/",
    [pagesId.toLowerCase()]: "/",
    [pressReleasesId.toLowerCase()]: "/ripple-press/",
    [componentCtaCardID.toLowerCase()]: "/ripplenet-committee/",
  }

  return contentUrlPathPrefixes[contentTypeId] || "/"
}

export default getContentTypePath

// Export the types for use in other files
export type { ContentTypeId, UrlPathPrefix, ContentTypeToUrlMapping }
